<template>
    <el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[12]"  element-loading-text="Loading...">
        <el-row :gutter="25">
            <el-col :lg="12" v-if="getScreenSize > 1 || delayedLoading[0]">
                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Format')">
                    <el-select v-model="getSettingsAudioRecording.format" :placeholder="$l('common/select')">
                        <el-option label="Wav" value="wav"></el-option>
                        <el-option label="Mp3" value="mp3"></el-option>
                        <el-option label="Raw" value="raw"></el-option>
                        <el-option label="Ogg Vorbis" value="ogg"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :lg="12" v-if="getScreenSize > 1 || delayedLoading[1]">
                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Audio Offset')">
                
                    <el-input-number :min="0" :max="30" v-model="getSettingsAudioRecording.offset"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-collapse v-if="getScreenSize > 1 || delayedLoading[2]">
                    <el-collapse-item :class="getClass('noise')" :title="$l('settings/audioRecording/Day')">
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/RecDur')"> 
                            <el-time-picker v-model="getSettingsAudioRecording.duration1Picker"
                                :picker-options="{
                                    selectableRange: '00:00:05 - 01:00:00'
                                }">
                            </el-time-picker>
                            <el-input-number v-show="false" :min="0" :max="3600" v-model="getSettingsAudioRecording.duration1" style="width: 100%;"></el-input-number> 
                        </el-form-item>
                        <el-row :gutter="25">
                            <el-col :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Threshold')">
                                    <el-select v-model="getSettingsAudioRecording.threshold1type" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold1type == 0 || getSettingsAudioRecording.threshold1type == 2" v-model="getSettingsAudioRecording.threshold1[0]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold1type == 0 || getSettingsAudioRecording.threshold1type == 1" v-model="getSettingsAudioRecording.threshold1[1]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Start')"> <el-input-number :min="0" :max="24" v-model="getSettingsAudioRecording.time1" style="width: 100%;"></el-input-number> </el-form-item>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Stop')"> <el-input-number disabled v-model="getSettingsAudioRecording.time1stop" style="width: 100%;"></el-input-number> </el-form-item>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-if="getScreenSize > 1 || delayedLoading[3]">
                    <el-collapse-item :class="getClass('noise')" :title="$l('settings/audioRecording/Night')">
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/RecDur')"> 
                            <el-time-picker v-model="getSettingsAudioRecording.duration2Picker"
                                :picker-options="{
                                    selectableRange: '00:00:00 - 01:00:00'
                                }">
                            </el-time-picker>
                            <el-input-number v-show="false" :min="0" :max="3600" v-model="getSettingsAudioRecording.duration2" style="width: 100%;"></el-input-number> 
                        </el-form-item>
                        <el-row :gutter="25">
                            <el-col :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Threshold')">
                                    <el-select v-model="getSettingsAudioRecording.threshold2type" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold2type == 0 || getSettingsAudioRecording.threshold2type == 2" v-model="getSettingsAudioRecording.threshold2[0]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold2type == 0 || getSettingsAudioRecording.threshold2type == 1" v-model="getSettingsAudioRecording.threshold2[1]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Start')"> <el-input-number :min="0" :max="24" :step="1" v-model="getSettingsAudioRecording.time1stop" style="width: 100%;"></el-input-number> </el-form-item>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Stop')"> <el-input-number disabled  v-model="getSettingsAudioRecording.time1" style="width: 100%;"></el-input-number> </el-form-item>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-if="getScreenSize > 1 || delayedLoading[4]">
                    <el-collapse-item :class="getClass('noise')" :title="$l('settings/audioRecording/Optional 1')">
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/RecDur')">
                            <el-time-picker v-model="getSettingsAudioRecording.duration3Picker"
                                :picker-options="{
                                    selectableRange: '00:00:05 - 01:00:00'
                                }">
                            </el-time-picker>
                            <el-input-number v-show="false" :min="0" :max="3600" v-model="getSettingsAudioRecording.duration3" style="width: 100%;"></el-input-number> 
                        </el-form-item>
                        <el-row :gutter="25">
                            <el-col :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Threshold')">
                                    <el-select v-model="getSettingsAudioRecording.threshold3type" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold3type == 0 || getSettingsAudioRecording.threshold3type == 2" v-model="getSettingsAudioRecording.threshold3[0]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold3type == 0 || getSettingsAudioRecording.threshold3type == 1" v-model="getSettingsAudioRecording.threshold3[1]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Start')"> <el-input-number :min="0" :max="24" :step="1" v-model="getSettingsAudioRecording.time3" style="width: 100%;"></el-input-number> </el-form-item>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Stop')"> <el-input-number :min="0" :max="24" :step="1" v-model="getSettingsAudioRecording.time3stop" style="width: 100%;"></el-input-number> </el-form-item>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-if="getScreenSize > 1 || delayedLoading[5]">
                    <el-collapse-item :class="getClass('noise')" :title="$l('settings/audioRecording/Optional 2')">
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/RecDur')"> 
                            <el-time-picker v-model="getSettingsAudioRecording.duration4Picker"
                                :picker-options="{
                                    selectableRange: '00:00:05 - 01:00:00'
                                }">
                            </el-time-picker>
                            <el-input-number v-show="false" :min="0" :max="3600" v-model="getSettingsAudioRecording.duration4" style="width: 100%;"></el-input-number> 
                        </el-form-item>
                        <el-row :gutter="25">
                            <el-col :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Threshold')">
                                    <el-select v-model="getSettingsAudioRecording.threshold4type" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12">
                                <el-row :gutter="25"> 
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold4type == 0 || getSettingsAudioRecording.threshold4type == 2" v-model="getSettingsAudioRecording.threshold4[0]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsAudioRecording.threshold4type == 0 || getSettingsAudioRecording.threshold4type == 1" v-model="getSettingsAudioRecording.threshold4[1]" :min="-10" :max="150" :step="0.1" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Start')"> <el-input-number :min="0" :max="24" :step="1" v-model="getSettingsAudioRecording.time4" style="width: 100%;"></el-input-number> </el-form-item>
                        <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Stop')"> <el-input-number :min="0" :max="24" :step="1" v-model="getSettingsAudioRecording.time4stop" style="width: 100%;"></el-input-number> </el-form-item>
                    </el-collapse-item>
                </el-collapse>
                <!-- Weather Triggers -->
                <el-collapse v-if="getScreenSize > 1 || delayedLoading[6]">
                    <el-collapse-item :class="getClass('weather')" :title="$l('settings/audioRecording/Weather')">
                        <el-row v-if="getScreenSize > 1 || delayedLoading[7]">
                            <el-col :lg="24">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/RecDur')">
                                    <el-time-picker v-model="getSettingsWeather.rectimePicker"
                                        :picker-options="{
                                            selectableRange: '00:00:05 - 01:00:00'
                                        }">
                                    </el-time-picker>
                                    <el-input v-show="false" v-model="getSettingsWeather.rectime" ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[8]">
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Windspeed')">
                                    <el-select v-model="getSettingsWeather.windsptrigtype" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsWeather.windsptrigtype == 0 || getSettingsWeather.windsptrigtype == 2" v-model="getSettingsWeather.windsptrig[0]" :min="0" :max="150" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsWeather.windsptrigtype == 0 || getSettingsWeather.windsptrigtype == 1" v-model="getSettingsWeather.windsptrig[1]" :min="0" :max="150" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[9]">
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Temperature')">
                                    <el-select v-model="getSettingsWeather.temptrigtype" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsWeather.temptrigtype == 0 || getSettingsWeather.temptrigtype == 2" v-model="getSettingsWeather.temptrig[0]" :min="-40" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsWeather.temptrigtype == 0 || getSettingsWeather.temptrigtype == 1" v-model="getSettingsWeather.temptrig[1]" :min="-40" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[10]">
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Air')">
                                    <el-select v-model="getSettingsWeather.airprtrigtype" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsWeather.airprtrigtype == 0 || getSettingsWeather.airprtrigtype == 2" v-model="getSettingsWeather.airprtrig[0]"  :min="300" :max="1200" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsWeather.airprtrigtype == 0 || getSettingsWeather.airprtrigtype == 1" v-model="getSettingsWeather.airprtrig[1]" :min="300" :max="1200" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[11]">
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Humidity')">
                                    <el-select v-model="getSettingsWeather.humidtrigtype" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsWeather.humidtrigtype == 0 || getSettingsWeather.humidtrigtype == 2" v-model="getSettingsWeather.humidtrig[0]" :min="0" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsWeather.humidtrigtype == 0 || getSettingsWeather.humidtrigtype == 1" v-model="getSettingsWeather.humidtrig[1]" :min="0" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[12]">
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-form-item  class="el-form-item-full" :label="$l('settings/audioRecording/Precipitation')">
                                    <el-select v-model="getSettingsWeather.precipittrigtype" :placeholder="$l('common/select')">
                                        <el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
                                        <el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="12">
                                <el-row :gutter="25">
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
                                                <el-input-number :disabled="getSettingsWeather.precipittrigtype == 0 || getSettingsWeather.precipittrigtype == 2" v-model="getSettingsWeather.precipittrig[0]" :min="0" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="line" :sm="2" :lg="2">
                                        <el-form-item  class="el-form-item-full pixel" label=" ">-</el-form-item>
                                    </el-col>
                                    <el-col :sm="11" :lg="11">
                                        <el-form-item  class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
                                                <el-input-number :disabled="getSettingsWeather.precipittrigtype == 0 || getSettingsWeather.precipittrigtype == 1" v-model="getSettingsWeather.precipittrig[1]" :min="0" :max="100" style="width: 100%;"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
    </el-form>
</template>

<style>
.pixel{
    margin-top:2px;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0}
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsAudioRecording',
            'getSettingsWeather',
            'getSettingsAddons',
            'getScreenSize'
        ]),
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },
        getClass:function(menu){
            if(this.getSettingsAddons[menu]=='0') return 'disabled-button';
            return '';
        },
    },
    mounted: function(){
        if(this.getSettingsAudioRecording.threshold1[0] == -20) this.threshold1LowerEnabled = false;
    
        setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 13) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// AudioRecording.vue?109466bd